module.exports = __webpack_public_path__ + "static/evento-sm-205f9462b1a57ac7453b6551255f5226.jpg";